var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectAppContent, selectMedia, selectStyles, selectDetectTimezoneAbbr, selectDsTimezoneAbbreviation, selectLocaleLanguage, selectTimezone } from "@adm-media/adam-store-plugin";
import classNames from "classnames";
import moment from "moment";
import { OpenLoginModalButton } from "../../../ui/Buttons/OpenLoginModalButton/OpenLoginModalButton";
import { DownOutlined } from "@ant-design/icons";
import { SanitizeHtml } from "../../../ui/SanitizeHtml/SanitizeHtml";
import HeroVideo from "../HeroVideo/HeroVideo";
import { BlockWrapper } from "../../../wrappers/BlockWrapper/BlockWrapper";
import { HeroDynamicStyles } from "../HeroDynamicStyles";
import Typography from "../../../ui/Typography/Typography";
import { useEpisodesToShowInHomepage } from "../../../../hooks/useEpisodesToShowInHomepage";
import { formatUtcDateInEventTimezone } from "../../../../utils/get-live-date";
import { utcToTimeZone } from "../../../../utils/timezone";
import { convertPHPToMomentFormat } from "../../../../utils/date";
import "../Hero.scss";
import "./HeroGynecologicalDays.scss";
var LIVE_STATUS_REFRESH_INTERVAL_MS = 30000;
var vodDateText = "Webcast will be trasmitted On demand on: 4 December 2026 09:00 CET";
export var HeroGynecologicalDays = function (_a) {
    var _b;
    var _c;
    var animation = _a.animation, props = __rest(_a, ["animation"]);
    var contents = useSelector(selectAppContent);
    var media = useSelector(selectMedia);
    var styles = useSelector(selectStyles);
    var timezone = useSelector(selectTimezone);
    var timezoneAbbreviation = useSelector(selectDetectTimezoneAbbr);
    var dsTimezoneAbbreviation = useSelector(selectDsTimezoneAbbreviation);
    var locale = useSelector(selectLocaleLanguage);
    var episodesToShowInHomepage = useEpisodesToShowInHomepage({ contents: contents, styles: styles }).episodesToShowInHomepage;
    var _d = useState(function () { return Date.now(); }), now = _d[0], setNow = _d[1];
    useEffect(function () {
        var interval = setInterval(function () { return setNow(Date.now()); }, LIVE_STATUS_REFRESH_INTERVAL_MS);
        return function () { return clearInterval(interval); };
    }, []);
    var animationInitialTimeout = 200;
    var animationTimeout = 400;
    var chronologicalEpisodes = __spreadArray([], episodesToShowInHomepage, true).sort(function (a, b) { var _a, _b, _c, _d; return new Date((_b = (_a = a.live_scheduling) === null || _a === void 0 ? void 0 : _a.start_at) !== null && _b !== void 0 ? _b : 0).getTime() - new Date((_d = (_c = b.live_scheduling) === null || _c === void 0 ? void 0 : _c.start_at) !== null && _d !== void 0 ? _d : 0).getTime(); });
    var formatDateOnly = function (date) {
        return formatUtcDateInEventTimezone({
            date: date,
            timezone: timezone,
            timeFormatType: contents.time_format,
            dateFormatType: contents.date_format,
            dsTimezoneAbbreviation: dsTimezoneAbbreviation,
            timezoneAbbreviation: timezoneAbbreviation,
            hideTime: true,
            locale: locale
        });
    };
    var formatStartTime = function (date) {
        var converted = utcToTimeZone({ time: date, zone: timezone, format: "YYYY-MM-DD HH:mm:ss" });
        if (!converted || !contents.time_format)
            return "";
        return moment(converted).format(convertPHPToMomentFormat(contents.time_format));
    };
    var formatEndTimeWithAbbreviation = function (date) {
        var _a;
        return (_a = formatUtcDateInEventTimezone({
            date: date,
            timezone: timezone,
            timeFormatType: contents.time_format,
            dateFormatType: contents.date_format,
            dsTimezoneAbbreviation: dsTimezoneAbbreviation,
            timezoneAbbreviation: timezoneAbbreviation,
            locale: locale,
            showOnlyTime: true
        })) === null || _a === void 0 ? void 0 : _a.trim();
    };
    var scrollToEndOfHeroBlock = function () {
        var agendaElement = document.getElementById("agenda");
        if (agendaElement) {
            agendaElement === null || agendaElement === void 0 ? void 0 : agendaElement.scrollIntoView({ behavior: "smooth" });
        }
        else {
            var arrowDown = document.querySelector(".hero-wrapper .hero-scroll-down-button");
            if (arrowDown)
                arrowDown === null || arrowDown === void 0 ? void 0 : arrowDown.scrollIntoView({ behavior: "smooth" });
        }
    };
    var handleEpisodeCardClick = function (episodeId) {
        var _a;
        scrollToEndOfHeroBlock();
        var tabButton = (_a = document.querySelector(".block-agenda [data-node-key=\"episode-agenda-tab-".concat(episodeId, "\"] .ant-tabs-tab-btn"))) !== null && _a !== void 0 ? _a : document.querySelector(".block-agenda [data-node-key=\"".concat(episodeId, "\"] .ant-tabs-tab-btn"));
        tabButton === null || tabButton === void 0 ? void 0 : tabButton.click();
    };
    return (_jsxs("div", __assign({ className: classNames("hero-wrapper", "hero-gynecological-days", "animation-ready") }, { children: [animation && _jsx(HeroDynamicStyles, { animationInitialTimeout: animationInitialTimeout, animationTimeout: animationTimeout }), _jsx("div", __assign({ className: classNames("hero-container", "isVideo", (_b = {}, _b["hero-animated-background"] = animation, _b)) }, { children: ((_c = media === null || media === void 0 ? void 0 : media.body_background_image_desktop) === null || _c === void 0 ? void 0 : _c.type) === "video" && _jsx(HeroVideo, { source: media.body_background_image_desktop.url }) })), _jsx(BlockWrapper, __assign({ noGutter: props.noGutter }, { children: _jsxs("div", __assign({ "data-testid": "block-hero-contents", className: "hero-contents centered" }, { children: [_jsx(Typography.Title, __assign({ level: 1, className: "hero-contents__title hero-animated-element" }, { children: _jsx(SanitizeHtml, { stringToSanitize: contents === null || contents === void 0 ? void 0 : contents.event_title, tag: "div" }) })), _jsx(Typography.Title, __assign({ level: 2, className: "hero-contents__subtitle hero-animated-element" }, { children: _jsx(SanitizeHtml, { stringToSanitize: contents === null || contents === void 0 ? void 0 : contents.sub_title, tag: "div" }) })), chronologicalEpisodes.map(function (episode) {
                            var _a, _b;
                            var liveStart = (_a = episode.live_scheduling) === null || _a === void 0 ? void 0 : _a.start_at;
                            var liveEnd = (_b = episode.live_scheduling) === null || _b === void 0 ? void 0 : _b.finish_at;
                            var isLive = !!liveStart && !!liveEnd && now >= new Date(liveStart).getTime() && now < new Date(liveEnd).getTime();
                            return (_jsx("div", __assign({ "data-testid": "hero-episode-card", className: classNames("hero-episode-card", "hero-animated-element", { "hero-episode-card--live": isLive }), onClick: function () { return handleEpisodeCardClick(episode.id); } }, { children: _jsxs("div", __assign({ className: "hero-episode-card__container" }, { children: [_jsx("div", __assign({ className: "hero-episode-card__title", dir: "auto" }, { children: episode.title })), _jsx("div", __assign({ className: "hero-episode-card__live-date" }, { children: formatDateOnly(liveStart) })), _jsxs("div", __assign({ className: "hero-episode-card__live-date" }, { children: ["Live from ", formatStartTime(liveStart), " to ", formatEndTimeWithAbbreviation(liveEnd)] }))] })) }), episode.id));
                        }), _jsx("div", __assign({ className: "hero-contents__vod-date hero-animated-element" }, { children: vodDateText })), _jsxs("div", __assign({ className: "hero-contents__cta-container hero-animated-element" }, { children: [_jsx(OpenLoginModalButton, { className: "hero-login-button", size: "large" }), _jsx(OpenLoginModalButton, { className: "hero-register-button", size: "large", defaultAuthState: "register" })] }))] })) })), _jsxs("div", __assign({ className: "hero-scroll-down-button", "aria-label": "Scroll down", tabIndex: 0, onClick: scrollToEndOfHeroBlock, onKeyDown: scrollToEndOfHeroBlock }, { children: [_jsx(DownOutlined, { className: "hero-scroll-down-icon hero-scroll-down-icon--1" }), _jsx(DownOutlined, { className: "hero-scroll-down-icon hero-scroll-down-icon--2" }), _jsx(DownOutlined, { className: "hero-scroll-down-icon hero-scroll-down-icon--3" })] }))] })));
};
export default HeroGynecologicalDays;
